import $ from 'jquery';

const $postContainer = $('.post-container');
const $postFeaturedImage = $('.post-featured-image');
const $postHeader = $('.post-header');
const $window = $(window);
const animationDuration = 1500;

let activeTimeout = null;

function enterPostContainer() {
  $postFeaturedImage.addClass('entering');
  activeTimeout = setTimeout(function () {
    $postHeader.removeClass('active');
    $postContainer.addClass('active');
    setTimeout(function () {
      $postFeaturedImage.removeClass('entering');
      activeTimeout = null;
    }, animationDuration / 2);
  }, animationDuration / 2);
}

function leavePostContainer() {
  $postFeaturedImage.addClass('leaving');
  activeTimeout = setTimeout(function () {
    $postHeader.addClass('active');
    $postContainer.removeClass('active');
    setTimeout(function () {
      $postFeaturedImage.removeClass('leaving');
      activeTimeout = null;
    }, animationDuration / 2);
  }, animationDuration / 2);
}

$(window).on('DOMMouseScroll mousewheel', function (event) {
  if (activeTimeout) return;
  let windowIsAtTop = $(window).scrollTop() <= 0;
  let windowIsAtBottom = $(window).scrollTop() + $(window).height() >= $(document).height();
  let isScrollingUp = event.originalEvent.detail < 0 || event.originalEvent.wheelDelta > 0;
  if (windowIsAtBottom && $postHeader.hasClass('active') && !isScrollingUp) {
    enterPostContainer();
  } else if (windowIsAtTop && $postContainer.hasClass('active') && isScrollingUp) {
    leavePostContainer();
  }
});

$('.scroll-down').click(function () {
  enterPostContainer();
});
